// External
import React from 'react';
import PropTypes from 'prop-types';

// Style
import style from './Header.scss';

export default function Header({ children }) {
  return <div className={style.summary_header}>{children}</div>;
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
};
